import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Breadcrumb from '../../components/ui/Breadcrumb';
import HeroSection from './components/HeroSection';
import CompanyHistory from './components/CompanyHistory';
import TeamExpertise from './components/TeamExpertise';
import MissionValues from './components/MissionValues';
import Achievements from './components/Achievements';
import Facilities from './components/Facilities';

const AboutUs = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background overflow-x-hidden about-us-page">
        {/* Breadcrumb */}
        <div className="bg-muted/30 py-4">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <Breadcrumb />
          </div>
        </div>

        {/* Page Content */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          {/* Hero Section */}
          <HeroSection />

          {/* Company History */}
          <CompanyHistory />

          {/* Mission & Values */}
          <MissionValues />

          {/* Team Expertise */}
          {/* <TeamExpertise /> */}

          {/* Achievements */}
          <Achievements />

          {/* Facilities */}
          {/* <Facilities /> */}  
        </motion.div>
    </div>
  );
};

export default AboutUs;